// Self-reference so the bundler resolves the impl through this package's
// `exports` map (react-server -> server, default -> browser). A relative
// import would bypass the conditional exports map and resolve to the
// type-only stub in ./impl/index.ts instead.
// eslint-disable-next-line import/no-extraneous-dependencies, local-rules/no-self-package-import
import { getFlogHeaders } from '@frameio/flog/impl';
import { asLogger, FLOG, type Logger } from './logger';

export { flush } from './sink';

export const flog = asLogger(async function flogImpl(
  message: string,
  ...props: object[]
) {
  const ts = { timestamp: Date.now() };
  FLOG(message, ts, ...props);
});

export { flog as default, getFlogHeaders, type Logger };
